<template>
  <div id="nav">
    <div class="container">
      <div class="row">
        <div class="col">
          <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="container-fluid">
              <a class="navbar-brand" href="#">
                <img src="~@/assets/images/latest-logo.png" class="logo-img img-fluid d-inline-block align-top">
              </a>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav me-auto">
                  <li class="nav-item">
                    <a class="nav-link active" aria-current="page" href="/">Home</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="https://shop.bloomsnature.com/about-us/">About Us</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="https://shop.bloomsnature.com/">Shop</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="https://shop.bloomsnature.com/contact-us/">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
name: "Navbar"
}
</script>

<style scoped>

</style>